import { useGetFolders } from '@utils/api/folders/use-get-folders.tsx';
import { Workspace } from '@components/main-workspace/workspace.tsx';
import type { SortOrder } from '@utils/localStorage/sort-order-storage.ts';

type WorkspaceTableProps = {
  sortOrder?: SortOrder;
};

export const WorkspaceTable = ({ sortOrder }: WorkspaceTableProps) => {
  const { data, isLoading, isFetching } = useGetFolders({ sortOrder });

  const fetchData = {
    data: data,
    isLoading: isLoading,
    isFetching: isFetching
  };

  return (
    <div className="px-2 sm:px-0 pb-4 sm:pb-0 flex-1 min-h-0 flex flex-col">
      <Workspace
        fetchData={fetchData}
        title="Workspace Title"
        caption="This is a caption for the workspace."
      />
    </div>
  );
};
